<ag-grid-angular [loading]="isLoading()" [rowData]="history()" [columnDefs]="columnDefs" [gridOptions]="tableDef"></ag-grid-angular>
